export default "__VITE_ASSET__D$L4XbD1__"